import { Button } from 'antd'
import dayjs from 'dayjs'
import { acessoRootAtual, sairDaEmpresa } from 'utils/acessoRoot'

// Sempre visível enquanto o root está dentro de um escritório: tudo o que ele fizer vale de verdade
export default function BarraAcessoRoot() {
  const acesso = acessoRootAtual()
  if (!acesso) return null
  return (
    <div
      role='status'
      style={{
        position: 'fixed', left: '50%', bottom: 12, transform: 'translateX(-50%)', zIndex: 1100, maxWidth: 'calc(100vw - 32px)',
        display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12, padding: '8px 14px', borderRadius: 10,
        background: '#b42318', color: '#fff', fontSize: 13, boxShadow: '0 4px 16px rgba(0,0,0,.25)',
      }}
    >
      <span>Você está no sistema de <strong>{acesso.nome}</strong>. O que fizer aqui vale de verdade e fica registrado. Até {dayjs(acesso.expiraEm).format('HH:mm')}.</span>
      <Button size='small' onClick={sairDaEmpresa}>Voltar ao painel</Button>
    </div>
  )
}
